import React from 'react';
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

const scopeOptions = [
  { value: 'all', label: 'All Scopes' },
  { value: 'dpe', label: 'DPE' },
  { value: 'appsheet', label: 'AppSheet' },
  { value: 'combined', label: 'Combined' },
];

const ReportsFilters = ({ filters, datasetOptions, onChange }) => {
  const update = (next) => onChange({ ...filters, ...next });

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
      <Stack spacing={2}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ xs: 'stretch', md: 'center' }}>
          <TextField
            size="small"
            label="Search"
            value={filters.search}
            onChange={(event) => update({ search: event.target.value })}
            placeholder="Search by name, description, or tags"
            sx={{ flex: 1 }}
          />
          <FormControl size="small" sx={{ minWidth: 180 }}>
            <InputLabel>Scope</InputLabel>
            <Select
              data-testid="reports-filters-scope"
              value={filters.scope}
              label="Scope"
              onChange={(event) => update({ scope: event.target.value })}
            >
              {scopeOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 220 }}>
            <InputLabel>Dataset</InputLabel>
            <Select
              value={filters.dataset}
              label="Dataset"
              onChange={(event) => update({ dataset: event.target.value })}
            >
              <MenuItem value="all">All Datasets</MenuItem>
              {datasetOptions.map((dataset) => (
                <MenuItem key={dataset.id} value={dataset.id}>
                  {dataset.label || dataset.id}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>

        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ xs: 'stretch', md: 'center' }}>
          <TextField
            size="small"
            type="date"
            label="Created After"
            value={filters.startDate}
            onChange={(event) => update({ startDate: event.target.value })}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            size="small"
            type="date"
            label="Created Before"
            value={filters.endDate}
            onChange={(event) => update({ endDate: event.target.value })}
            InputLabelProps={{ shrink: true }}
          />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Quick filters:
            </Typography>
            <Chip
              label="Created last 7 days"
              color={filters.recentOnly ? 'primary' : 'default'}
              variant={filters.recentOnly ? 'filled' : 'outlined'}
              onClick={() => update({ recentOnly: !filters.recentOnly })}
            />
            <Chip
              label="Clear"
              variant="outlined"
              onClick={() =>
                update({
                  search: '',
                  scope: 'all',
                  dataset: 'all',
                  startDate: '',
                  endDate: '',
                  recentOnly: false,
                })
              }
            />
          </Box>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default ReportsFilters;
